import { Head, useForm } from '@inertiajs/react'
import Layout from '../components/Layout'

export default function Settings({ settings, timeZones }) {
  const { data, setData, patch, processing, errors } = useForm({
    name: settings.name || '',
    tagline: settings.tagline || '',
    born_on: settings.bornOn || '',
    born_time: settings.bornTime || '',
    time_zone: settings.timeZone || '',
  })

  function submit(event) {
    event.preventDefault()
    patch('/baby')
  }

  return (
    <Layout>
      <Head title="Nursery settings" />

      <div className="mx-auto max-w-xl">
        <h1 className="font-display text-4xl font-extrabold text-ink">Nursery settings 🌙</h1>
        <p className="mt-2 mb-6 text-lg text-ink-soft">
          The little details that show up across the album.
        </p>

        <form onSubmit={submit} className="card-cute space-y-5 p-6">
          <div>
            <label htmlFor="name" className="mb-1.5 block font-display font-bold text-ink-soft">
              Baby&rsquo;s name
            </label>
            <input
              id="name"
              type="text"
              value={data.name}
              onChange={(event) => setData('name', event.target.value)}
              required
              maxLength={60}
              className="input-cute"
            />
            {errors.name && <p className="mt-1 text-sm font-bold text-rose-600">{errors.name}</p>}
          </div>

          <div>
            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <label htmlFor="born_on" className="mb-1.5 block font-display font-bold text-ink-soft">
                  Birthday
                </label>
                <input
                  id="born_on"
                  type="date"
                  value={data.born_on || ''}
                  onChange={(event) => setData('born_on', event.target.value)}
                  className="input-cute"
                />
              </div>

              <div>
                <label htmlFor="born_time" className="mb-1.5 block font-display font-bold text-ink-soft">
                  Time of birth <span className="font-normal">(optional)</span>
                </label>
                <input
                  id="born_time"
                  type="time"
                  value={data.born_time || ''}
                  onChange={(event) => setData('born_time', event.target.value)}
                  className="input-cute"
                />
              </div>
            </div>

            <label htmlFor="time_zone" className="mt-4 mb-1.5 block font-display font-bold text-ink-soft">
              Where they were born
            </label>
            <select
              id="time_zone"
              value={data.time_zone}
              onChange={(event) => setData('time_zone', event.target.value)}
              className="input-cute cursor-pointer"
            >
              {timeZones.map((zone) => (
                <option key={zone.value} value={zone.value}>
                  {zone.label}
                </option>
              ))}
            </select>

            {errors.born_on && <p className="mt-1 text-sm font-bold text-rose-600">{errors.born_on}</p>}
            {errors.time_zone && <p className="mt-1 text-sm font-bold text-rose-600">{errors.time_zone}</p>}

            <p className="mt-1.5 text-sm text-ink-soft/80">
              The time and zone keep the age badge honest — a baby born at 11pm is an hour old at
              midnight, not a day.
            </p>
          </div>

          <div>
            <label htmlFor="tagline" className="mb-1.5 block font-display font-bold text-ink-soft">
              Tagline
            </label>
            <input
              id="tagline"
              type="text"
              value={data.tagline}
              onChange={(event) => setData('tagline', event.target.value)}
              maxLength={120}
              placeholder="Freshly baked, mostly asleep."
              className="input-cute"
            />
            {errors.tagline && <p className="mt-1 text-sm font-bold text-rose-600">{errors.tagline}</p>}
          </div>

          <button type="submit" disabled={processing} className="btn-cute bg-blush-400 text-white shadow hover:bg-blush-500">
            Save settings
          </button>
        </form>
      </div>
    </Layout>
  )
}
